import React, { Component } from 'react';
import "./Promo.scss"
import ScrollableAnchor from 'react-scrollable-anchor'
import { setScrollNaming } from '../../Services/ScrollURL';

class Promo extends Component {
  constructor() {
    super();
    this.state = {}
  }
  componentDidMount() {
    setScrollNaming(this.section);
  }
  render() {
    return (
      <section className="section section-promo" ref={section => this.section = section}>
        <div className="padding">
          <div className="container">
            <div className="headline">
              <div className="head">
                איך זה מרגיש<span></span>
              </div>
              <div className="teaser">
                תמיד חשבנו שלפחות מבחינה רגשית, לבני האדם תמיד יהיה יתרון על פני הטכנולוגיה. <span>אבל מה יקרה כשגם למכשירים שסביבנו יהיו תחושות?</span>
              </div>
            </div>
          </div>
          <div className="arrow" onClick={() => this.props.setTransform(1)}></div>
        </div>
      </section>
    );
  }
}

export default Promo;



// WEBPACK FOOTER //
// ./src/Components/Screens/0_Promo/Promo.jsx